// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__6-kto","redirUrl":"NotFound_redirUrl__pKxRi"};